export const SET_VARIABLE_VALUES_TOOL_NAME = "set_variable_values";
